import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Accordion, Stack } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { LoanSummaryRow } from './LoanSummaryRow';
import { Rate, VariableRate } from '../../../../../../../ui/rate';
import { useLoanSummary } from '../../hooks/useLoanSummary';

type MobileLoanSummaryProps = {
    formalOffer: TFormalOffer;
    drawdownAmount: number;
};

export const MobileLoanSummary = ({
    formalOffer,
    drawdownAmount
}: MobileLoanSummaryProps) => {
    const { interestRate, withdrawalFeePercentage, fullTermMonths } =
        useLoanSummary(formalOffer, drawdownAmount);

    return (
        <Accordion.Item
            data-testid="mobile-loan-summary"
            variant="secondary"
            size="large"
            className="rounded-s bg-secondary-95"
        >
            <Accordion.Header>
                <Accordion.Title className="text-m font-bold text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.loan_summary.title"
                        defaultMessage="Your loan summary"
                    />
                </Accordion.Title>
                <Accordion.Trigger />
            </Accordion.Header>
            <Accordion.Content>
                <Stack>
                    <LoanSummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.withdrawal_amount"
                                defaultMessage="Withdrawal amount:"
                            />
                        }
                        value={<FormattedCurrency value={drawdownAmount} />}
                    />
                    <LoanSummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.interest_rate"
                                defaultMessage="Interest rate /30 days:"
                            />
                        }
                        value={<Rate value={interestRate} />}
                    />
                    <LoanSummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.withdrawal_fees"
                                defaultMessage="Withdrawal fees:"
                            />
                        }
                        value={
                            <VariableRate
                                minimumFractionDigits={0}
                                maximumFractionDigits={2}
                                value={withdrawalFeePercentage}
                            />
                        }
                    />
                    <LoanSummaryRow
                        label={
                            <FormattedMessage
                                id="_.loan_summary.full_term_duration"
                                defaultMessage="Full term duration:"
                            />
                        }
                        value={
                            <FormattedMessage
                                id="_.loan_summary.full_term_months"
                                defaultMessage="{months} months"
                                values={{ months: fullTermMonths }}
                            />
                        }
                    />
                </Stack>
            </Accordion.Content>
        </Accordion.Item>
    );
};
